import axios from "axios";
import { detailServicesPath} from "../../../Constants";

const samplesControllerRestUrl = detailServicesPath + '/customers/detail-samples/group'
export default class SamplesControllerServiceGroup {

    static async getAll() {
        return axios.get(`${samplesControllerRestUrl}`);
    }
    static async getAllRoot() {
        return axios.get(`${samplesControllerRestUrl}/root`);
    }

    static async save(data) {
        return await axios.post(`${samplesControllerRestUrl}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(groupId) {

        return await axios.delete(`${samplesControllerRestUrl}/${groupId}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async edit(groupId, data) {
        return await axios.put(`${samplesControllerRestUrl}/${groupId}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

}